<template>
  <div style="width: 560px;">
    <a-alert :show-icon="true" type="warning">
      <div slot="message">
        <div>* 直播图片列表内穿插营销广告</div>
      </div>
    </a-alert>
    <a-spin :spinning="searching">
      <div style="margin-top:15px;">
        <div v-for="(item, index) in result.data" :key="index" class="advert">
          <a-space :size="15">
            <a :href="item.config.link" target="_blank">
              <ResourceImg :id="item.cover" :height="120"/>
            </a>
            <div>
              <a-space :size="16">
                <b>{{ item.config.name }}</b>
                <span><a-icon type="eye"/> {{ item.visited }}</span>
              </a-space>
              <div style="height:65px;overflow:hidden;margin-bottom:5px;font-size:12px;color:#999;">
                {{ item.config.desc }}
              </div>
              <a-space>
                <a-button icon="edit" size="small" shape="round" @click="update(item)">编辑</a-button>
                <a-popconfirm title="您确认要删除吗？" @confirm="remove(item)">
                  <a-button type="danger" icon="delete" size="small" shape="round">删除</a-button>
                </a-popconfirm>
              </a-space>
            </div>
          </a-space>
        </div>
        <div style="margin-top:15px;">
          <a-button icon="plus" size="large" @click="create" type="dashed" block>添加</a-button>
        </div>
        <AdvertForm ref="form" :album-id="album.id" @saved="refresh"/>
      </div>
    </a-spin>
  </div>
</template>

<script>
import api from "@/utils/api";
import AdvertForm from "@/pages/index/album/config/comps/AdvertForm";
import ResourceImg from "@/comps/ResourceImg";

export default {
  name: "Advert",
  components: {ResourceImg, AdvertForm},
  props: {album: Object},
  data() {
    return {
      result: {
        total: 0,
        data: []
      },
      searching: false,
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    create() {
      this.$refs.form.open();
    },
    update(item) {
      this.$refs.form.open(item);
    },
    refresh() {
      this.searching = true;
      api.v1.album.advert.search(this.album.id)
          .then(res => this.result = res)
          .finally(() => this.searching = false);
    },
    remove(item) {
      return api.v1.album.advert.delete(this.album.id, item.id).then(this.refresh);
    }
  }
}
</script>

<style scoped lang="less">
.advert {
  padding: 10px;
  border-radius: 4px;
  margin-top: 15px;
  border: 1px #ddd solid;

  b {
    display: block;
    margin-bottom: 4px;
  }
}
</style>